import DescriptionSection from '../../../components/molecules/descriptionSection/DescriptionSection';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const DescriptionSectionTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <DescriptionSection
      title={data.title}
      description={data.description}
      descriptionStyles={data.descriptionStyles}
      placement={data.placement}
    />
  );
};

export default tastify({
  translate: true,
  connect: {
    context: true,
  },
})(DescriptionSectionTastic);
